import './Switcher.css';
import 'simplebar-react/dist/simplebar.min.css';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import SimpleBar from 'simplebar-react';
// import { SwitchTransition, CSSTransition } from "react-transition-group";

// import { useSwipeable } from "react-swipeable";
// import Loading from "@views/Loading";
import isLoading from '@selectors/isLoading';
import { getNext, getPrev } from '@selectors/location';

import config from '@config';
import Pages from '@pages';
import Error from '@views/Error';

export const UniversalComponent = ({ page, hasError }) => {
  if (!Object.keys(Pages).includes(page)) return null;

  let Page = Pages[page];

  return hasError ? (
    <Error message="Ocurrió un error en la aplicación." />
  ) : (
    <Fragment>
      <Page />
      <footer
        style={{ backgroundImage: `url(${config.basePath}/img/pasto-footer.jpg)` }}
      ></footer>
    </Fragment>
  );
};

export const Switcher = ({
  page,
  direction,
  isLoading,
  redirect,
  next,
  prev,
  hasError,
}) => {
  /*
  const handlers = useSwipeable({
    onSwipedLeft: next && redirect(next),
    onSwipedRight: prev && redirect(prev),
    delta: 150,
  });
*/

  return (
    <div className={`switcher ${direction}`}>
      <SimpleBar style={{ height: '100%' }}>
        <UniversalComponent page={page} hasError={hasError} />
      </SimpleBar>
    </div>
  );
  /*
  return (
    <div className="switcher">
      <SwitchTransition>
        <CSSTransition key={page} className={`${direction} fade`}>
          <div {...handlers}>
            <UniversalComponent page={page} hasError={hasError} />
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
  */
};

/*
 <Transition key={page}>
    {isLoading ? (
      <div>
        <UniversalComponent page={page} />
        <Loading />
      </div>
    ) : (
      <div {...handlers} >
        <UniversalComponent page={page} hasError={hasError} />
      </div>
    )}
  </Transition>
  */
export const mapStateToProps = (state) => ({
  page: state.page,
  direction: state.direction,
  isLoading: isLoading(state),
  next: getNext(state),
  prev: getPrev(state),
  hasError: state.applicationError,
});

export const mapDispatchToProps = (dispatch) => ({
  redirect: (to) => () => dispatch({ type: to }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Switcher);
